import { Injectable } from "@angular/core";

@Injectable()
export class Settings {
    apiUrl = "https://apicms.webmonkeyz.com/api/";
    websiteId = 4;
    googleAnalyticsId = "";
    emailTo = "info@webmonkeyz.com";
    emailFrom = "noreply@web-monkeyz.com";
    itemsPerPage = 6;
    version = "1.0.0";
}
